import React from 'react';
import PropTypes from 'prop-types';
import { Container } from 'components/atoms';
import { FeaturedCard, SectionHeader } from 'components/molecules';
import './FeaturedContent.scss';


const Header = (props) => {
	const { title, description, pageType, moduleType = '' } = props;

	switch (pageType) {
		case 'PSP':
			return (
				<SectionHeader
					className={`${pageType.toLowerCase()}-header`}
					title={title}
					titleProps={{
						size: moduleType === 'blogPosts' ? 'xlarge' : 'large',
						weight: 'ultraBold',
						color: 'black',
						family: moduleType === 'blogPosts' ? 'rounded' : 'default',
					}}
					description={description}
					contentAlign="text-left"
					additionalProps={{
						paragraph: { size: 'tall', color: 'black' },
					}}
				/>
			);
		case 'SGP':
			return (
				<SectionHeader
					className={`${pageType.toLowerCase()}-header`}
					title={title}
					titleProps={{
						size: 'large',
						weight: 'ultraBold',
						color: 'black',
						family: 'rounded',
					}}
					description={description}
					additionalProps={{
						paragraph: { size: 'tall', color: 'black' },
					}}
				/>
			);
		default:
			return null;
	}
};

export function FeaturedContent(props) {
	const { pageType, title, contentCards, description, ctaButton, moduleType } = props;
	return (
		<section className={`featured-card-section${moduleType === 'blogPosts' ? ' blog-posts-section' : ''}`}>
			<Header
				title={title}
				description={description}
				pageType={pageType}
				moduleType={moduleType}
			/>
			<Container>
				<div
					className={`featured-unit-cards-arrangement ${
						contentCards.length === 4 ? 'four-items-grid' : ''
					}`}
				>
					{contentCards.map((contentCard, index) => (
						<FeaturedCard
							contentCard={contentCard}
							index={index}
							totalItems={contentCards.length}
							key={contentCard.title}
							pageType={pageType}
						/>
					))}
				</div>
				{ctaButton && (
					<a
						href={ctaButton.href}
						className="featured-content-cta"
						target="_blank"
						rel="noopener noreferrer"
					>
						{ctaButton.label}
					</a>
				)}
			</Container>
		</section>
	);
}

Header.propTypes = {
	title: PropTypes.string,
	description: PropTypes.string,
	pageType: PropTypes.string,
	moduleType: PropTypes.string,
};
FeaturedContent.propTypes = {
	pageType: PropTypes.string,
	title: PropTypes.string,
	description: PropTypes.string,
	contentCards: PropTypes.array.isRequired,
	ctaButton: PropTypes.shape({
		label: PropTypes.string,
		href: PropTypes.string,
	}),
	moduleType: PropTypes.string,
};

FeaturedContent.defaultProps = {
	pageType: 'PSP',
	title: 'Related Content',
	moduleType: '',
};

export default FeaturedContent;
